/**
 * Created by rathompson on 1/5/22
 * File: OnboardingCard
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { useMemo } from 'react'
import PropTypes from 'prop-types'

const OnboardingCard = ({ children, appearance }) => {

  const borderColor = useMemo(() => {
    switch (appearance) {
      case 'activated':
        return 'tw-border-blue'
      case 'onboarding':
      default:
        return 'tw-border-green'
    }
  }, [appearance])

  return (
    <div
      style={{ background: 'linear-gradient(180deg, #FFFFFF 0.89%, #FAFAFA 100.89%)' }}
      className={`${borderColor} tw-border-solid tw-border-2 tw-flex tw-flex-col tw-rounded tw-m-4 tw-relative`}
    >
      {children}
    </div>
  )
}

OnboardingCard.propTypes = {
  appearance: PropTypes.oneOf([
    'onboarding',
    'activated'
  ])
}

OnboardingCard.defaultProps = {
  appearance: 'onboarding'
}

export default OnboardingCard
